@if (loaderStore.isLoading()) {
  <div class="sb-loader-overlay">
    <nz-spin nzSimple [nzSize]="'large'" />
  </div>
}
